<template>
  <el-dialog
  :title="operate == 'add'?'增加项目':'编辑项目'"
  :visible.sync="dialogVisible"
  width="1200px"
  :before-close="handleClose">
    <div class="common-space-between">
      <div class="from">
        <el-form ref="form" :model="searchForm" :rules="rules" label-width="90px" label-position="left">
          <el-form-item label="项目名称" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入项目名称" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="项目类型" prop="projectType">
            <el-select style="width:100%" v-model="searchForm.projectType" placeholder="请选择">
              <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属地区" prop="areaAddress">
            <city ref="codeAddress" width="100%" @getVal="selectCity"></city>
          </el-form-item>
          <el-form-item label="项目详址" prop="address">
            <!-- <el-input v-model="searchForm.address" placeholder="请输入项目详址" size="small" clearable></el-input> -->
            <el-autocomplete style="width: 100%;"  v-model="searchForm.address" :fetch-suggestions="querySearch"  placeholder="请输入项目详址"  @select="handleSelect"></el-autocomplete>
          </el-form-item>
          <el-form-item label="联系人" prop="contacts">
            <el-input v-model="searchForm.contacts" placeholder="请输入联系人" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="searchForm.phone" maxlength="11" placeholder="请输入手机号码" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="marks">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="searchForm.marks" clearable>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="map" style="overflow: hidden;">
        <mymap ref="map" @setAddress="setAddress" :isEdit="isEdit"></mymap>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addAgent">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import City from '@/components/component-PcrIo/index.vue'
import mymap from './block_map.vue'
import { postFun, getFun, putFun } from "@/utils/httpFun";
import { rules } from "@/utils/config";
import { url } from "@/utils/config";
export default {
  components: {
    City,
    mymap
  },
  data() {
    return {
      operate: {},
      edits: {},
      dialogVisible:false,
      option: [
        {
          value: 1,
          label: '消防'
        },
        {
          value: 2,
          label: '新能源'
        }],
      disabled: false,
      searchForm: {
        name: '',                // 项目名称
        projectType: '',         // 项目类型
        address: '',             // 地址
        areaAddress: '',         // 省市区地址
        codeAddress: '',         // 省市区code
        longiLatitude: '',       // 经纬
        contacts: '',            // 联系人
        phone: '',               // 手机号
        marks: '',               // 备注
      },
      isEdit:false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        contacts:[
        {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            pattern: rules.PHONE,
            message: "请输入（正确）手机号码",
            trigger: "blur",
          },
        ],
        projectType: [
          {
            required: true,
            message: "请选择项目类型",
            trigger: "blur",
          },
        ],
        areaAddress: [
          {
            required: true,
            message: "请选择省市区",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入项目详址",
            trigger: "blur",
          },
        ],
        contacts: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          }
        ]
      },
      roles: [],
      isAddress: false,
    };
  },
  mounted() {
    this.init();
    this.$emit('SetPageSize', 1300);
  },
  methods: {
    handleSelect(obj){
      this.$refs.map.handleSelect(obj);
    },
    querySearch(querySearch,cd){
      this.$refs.map.querySearch(querySearch,cd);
    },
    open(operate,item){
      this.operate =  operate;
      this.edits = item;
      this.dialogVisible = true;
    },
    handleClose(){
      this.searchForm = {
        name: '',                // 项目名称
        projectType: '',         // 项目类型
        address: '',             // 地址
        areaAddress: '',         // 省市区地址
        codeAddress: '',         // 省市区code
        longiLatitude: '',       // 经纬
        contacts: '',            // 联系人
        phone: '',               // 手机号
        marks: '',               // 备注
      }

      this.$refs.codeAddress.clearBtn()

      this.dialogVisible = false;
    },
    selectCity(city) {

      const proveName = (city && city.AProve && city.AProve.name) || "";
      const cityName = (city && city.BCity && city.BCity.name) || "";
      const countryName = (city && city.COunty && city.COunty.name) || "";

      const proveadcode = (city && city.AProve && city.AProve.adcode) || "";
      const cityadcode = (city && city.BCity && city.BCity.adcode) || "";
      const countryadcode = (city && city.COunty && city.COunty.adcode) || "";

      if (proveName) {
        this.searchForm.areaAddress = `${proveName}`;
        this.searchForm.codeAddress = `${proveadcode}`;
      }
      if (cityName) {
        this.searchForm.areaAddress = `${proveName},${cityName}`;
        this.searchForm.codeAddress = `${proveadcode},${cityadcode}`;
      }
      if (countryName) {
        this.searchForm.areaAddress = `${proveName},${cityName},${countryName}`;
        this.searchForm.codeAddress = `${proveadcode},${cityadcode},${countryadcode}`;
      }
      !proveName &&
        !cityName &&
        !countryName &&
        (this.searchForm.address = "") && (this.searchForm.codeAddress = "");
      this.searchForm.longiLatitude = city.COunty.center;
      let center = city.COunty.center.split(',');
      // console.log("")
      if (!this.isAddress) {
        this.$refs.map.getClickInfo({ point: { lng: center[0], lat: center[1] } }, false)
      }
      this.isAddress = false;
    },
    setAddress(value, arrCode) {
      console.log("arra", arrCode)
      console.log('value',value)

      // 截取省市区 var reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
      //console.log(urlData.addr.match(reg)) // ['广东省','广州市','白云区']
    
      
      if (arrCode.code) {
        this.isAddress = true;
        console.log("测试arrcode", arrCode.code)
        this.$refs.codeAddress.setVal(arrCode.code)
      }

      this.searchForm.address = value;
    },
    init() {
      const width = document.body.clientWidth * 0.35;

      if (this.operate === "edit") {
        console.log('项目编辑',this.edits)
        let codeArr = this.edits.longiLatitude.split(",");
        let obj = {
          point:{lng:codeArr[0],lat:codeArr[1]},
        }
        this.isEdit = true;
        this.searchForm = this.edits;
        this.disabled = true;
        let address = this.searchForm.codeAddress.split('/').length == 1 ?this.searchForm.codeAddress.split(','): this.searchForm.codeAddress.split('/');
        console.log('测试----------',address)
        try{
          this.$refs.map.getClickInfo(obj)
        }catch{
          
        }
        this.$nextTick(() => {
          console.log('测试----------111')
          // this.$refs.map.getClickInfo(obj)
          this.$refs.codeAddress.setVal(address)
        })
      }
    },
    addAgent() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let params = ''

          let urlone = ''
          let txt = ''

          if (this.operate === "edit") {
            params = {
              id: this.edits.id,
              projectType: this.searchForm.projectType,
              name: this.searchForm.name,                      // 项目名称
              address: this.searchForm.address,                // 地址
              areaAddress: this.searchForm.areaAddress,        // 省市区地址
              codeAddress: this.searchForm.codeAddress,        // 省市区code
              longiLatitude: this.searchForm.longiLatitude,    // 经纬
              contacts: this.searchForm.contacts,              // 联系人
              phone: this.searchForm.phone,                    // 手机号
              marks: this.searchForm.marks,                    // 备注
            }
            urlone = `/project/update`
            txt = '编辑'

            putFun(url.PROJECT.UPDATEPROJECT, params, (res) => {
              if (res.code == 1) {
                this.$message({
                  message: txt + "成功",
                  type: "success",
                });
              } else {
                this.$message.warning(txt + "失败");
              }
              // this.$parent.close();
              this.$bus.$emit('close', '')
              this.$bus.$emit('getList', '')
            });
          } else {

            params = {
              projectType: this.searchForm.projectType,
              name: this.searchForm.name,                      // 项目名称
              address: this.searchForm.address,                // 地址
              areaAddress: this.searchForm.areaAddress,        // 省市区地址
              codeAddress: this.searchForm.codeAddress,        // 省市区code
              longiLatitude: this.searchForm.longiLatitude,    // 经纬
              contacts: this.searchForm.contacts,              // 联系人
              phone: this.searchForm.phone,                    // 手机号
              marks: this.searchForm.marks,                    // 备注
            }
            // urlone = `/project/addProject`
            txt = '增加'
            postFun(url.PROJECT.ADDPROJECT, params, (res) => {
              // console.log("增加",res)
              if (res.data) {
                this.$message({
                  message: txt + "成功",
                  type: "success",
                });
              } else {
                this.$message.warning(txt + "失败");
              }
              // this.$parent.getList();

              this.$bus.$emit('close', '')
              this.$bus.$emit('getList', '')
            });
          }
          // this.$emit('close')
        }
      });
    },
    clear() {
      this.searchForm = {
        name: '',                // 项目名称
        projectType: '',         // 项目类型
        address: '',             // 地址
        areaAddress: '',         // 省市区地址
        codeAddress: '',         // 省市区code
        longiLatitude: '',       // 经纬
        contacts: '',            // 联系人
        phone: '',               // 手机号
        marks: '',               // 备注
      }

      this.$refs.codeAddress.clearBtn()
    },
    close() {
    },
  },
};
</script>
<style lang="scss" scoped>

.from{
  width:400px;
}
.map{
  width:740px; 
}
::v-deep .el-input_inner {
  width: 166%;
}
</style>
